/* tslint:disable */
/* eslint-disable */
/**
 * TOM OPERATIONS SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */




export const EquipmentType = {
    Sts: 'STS',
    Rtg: 'RTG',
    Rs: 'RS',
    Ech: 'ECH',
    Tt: 'TT',
    Sc: 'SC',
    Fl: 'FL',
    Rmg: 'RMG',
} as const;

export type EquipmentType = typeof EquipmentType[keyof typeof EquipmentType];



